import React, { Fragment, useEffect, useState } from 'react';
import {
	Box,
	Typography,
	FormControl,
	TextField,
	InputAdornment,
	List,
	ListItem,
	Avatar,
	FormControlLabel,
	Checkbox,
	Tooltip,
	Chip,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { CrossIcon, SearchIcon, SortingIcon } from '../../../../../config/svg/CommonSvgIcon';
import { BorderCheckboxIcon, CheckedIcon, UnCheckedIcon } from '../../../../../config/svg/formElementIcons';
import NouserImg from '../../../../../images/search-no-colleagues.svg';
import { NoRecord } from '../../../CommonComponent/NoRecord';

export const SkillRoleList: React.FC<any> = (props: any) => {
	const { titleHead, rolesData, checkedUser, setCheckedUser, disabledUsers } = props;
	const { t } = useTranslation();

	const [localRoleList, setLocalRoleList] = useState<any>([]);
	const [searchValue, setSearchValue] = useState('');
	const [searchTextArray, setSearchTextArray] = useState<string>('');
	const [checkedAll, setCheckedAll] = useState(false);
	const [sortOrder, setSortOrder] = useState<string>('asc');
	const [sortingColumn, setSortingColumn] = useState<string>('');

	useEffect(() => {
		setLocalRoleList(rolesData && rolesData?.length ? rolesData : []);
		resetCheckState();
	}, [rolesData]);

	// ===================================================
	const resetCheckState = () => {
		setCheckedAll(false);
		//setCheckedUser([]);
	};
	const clearSearch = () => {
		setSearchTextArray('');
		setLocalRoleList(rolesData && rolesData?.length ? rolesData : []);
		resetCheckState();
	};
	const handleSearchClicked = (e: any) => {
		setSearchValue(e.target.value);
	};
	const searchClicked = (e: any) => {
		if (e.key === 'Enter') {
			const { value } = e?.target || {};
			if (value && value.trim() !== '') {
				setSearchTextArray(value);
				let updatedRoleList = rolesData && rolesData?.length ? rolesData : [];
				updatedRoleList = updatedRoleList?.filter(
					(rec: any) =>
						rec?.performanceRoleName && rec?.performanceRoleName?.toLowerCase().includes(value.toLowerCase())
				);
				setLocalRoleList(updatedRoleList);
				resetCheckState();
			}
			setSearchValue('');
		}
	};
	// =====================================================

	const handleAllChecked = (e: any) => {
		if (e.target.checked) {
			setCheckedAll(true);
			//======= filter Already selected userId
			const newUserList = localRoleList.filter((user: any) => {
				if (
					typeof checkedUser.find((item: any) => item.performanceRoleId === user.performanceRoleId) === 'undefined' &&
					typeof disabledUsers.find((item: any) => item.performanceRoleId === user.performanceRoleId) === 'undefined'
				) {
					return true;
				} else {
					return false;
				}
			});
			//====== get all userId in the page
			let newList = newUserList.map(
				(user: any) =>
					typeof checkedUser.find((item: any) => item.performanceRoleId === user.performanceRoleId) === 'undefined' && {
						...user,
					}
			);
			setCheckedUser(newList.concat(checkedUser) || []);
		} else {
			setCheckedAll(false);

			const filterUnselected = checkedUser.filter((chkUser: any) => {
				if (
					typeof localRoleList.find((item: any) => item.performanceRoleId === chkUser.performanceRoleId) === 'undefined'
				) {
					return true;
				} else {
					return false;
				}
			});
			setCheckedUser(filterUnselected);
		}
	};
	const getSelectedUserLength = () => {
		const selectedUserCount = localRoleList.filter((chkUser: any) => {
			if (
				typeof checkedUser.find((item: any) => item.performanceRoleId === chkUser.performanceRoleId) === 'undefined'
			) {
				return false;
			} else {
				return true;
			}
		});
		return selectedUserCount.length;
	};
	const onUserSelect = (e: any, rec: any, index: number) => {
		const { checked } = e.target;
		if (checked) {
			const isExist = checkedUser.find((chkUser: any) => rec?.performanceRoleId === chkUser?.performanceRoleId);
			if (!isExist) {
				setCheckedUser([...checkedUser, rec]);
			}
		} else {
			const filteredList = checkedUser.filter((chkUser: any) => rec?.performanceRoleId !== chkUser?.performanceRoleId);
			setCheckedUser([...filteredList]);
		}
	};

	return (
		<>
			<Box className='default-role-list'>
				<Box className='default-role-list-inner'>
					{searchTextArray || (localRoleList && localRoleList?.length) ? (
						<Box className='title-head'>
							<Typography variant='h6'>
								{titleHead || t('Roles')} ({localRoleList && localRoleList?.length ? localRoleList?.length : 0})
							</Typography>
							<Box className='user-search'>
								<TextField
									className='search-text-field'
									id='user-src-field'
									placeholder={t('searchText')}
									fullWidth
									value={searchValue}
									InputProps={{
										startAdornment: (
											<InputAdornment position='start'>
												<SearchIcon />
											</InputAdornment>
										),
									}}
									onChange={(e) => handleSearchClicked(e)}
									onKeyDown={(e) => searchClicked(e)}
								/>

								{searchTextArray && (
									<Box className='user-search-chip'>
										<List>
											<ListItem>
												{searchTextArray.length > 20 ? (
													<Tooltip title={searchTextArray} arrow>
														<Chip
															label={searchTextArray.substring(0, 20) + '...'}
															onDelete={clearSearch}
															deleteIcon={
																<span>
																	<CrossIcon />
																</span>
															}
														/>
													</Tooltip>
												) : (
													<Chip
														label={searchTextArray}
														onDelete={clearSearch}
														deleteIcon={
															<span>
																<CrossIcon />
															</span>
														}
													/>
												)}
											</ListItem>
										</List>
									</Box>
								)}
							</Box>
						</Box>
					) : (
						<></>
					)}
					{localRoleList && localRoleList?.length ? (
						<Box className='users-listing'>
							<Box className='okr-list-panel-head'>
								<List component='ul' disablePadding>
									<ListItem className='user-col1'>
										<FormControlLabel
											control={
												<Checkbox
													checked={checkedAll}
													onChange={(e) => handleAllChecked(e)}
													icon={<BorderCheckboxIcon />}
													checkedIcon={<CheckedIcon />}
													indeterminateIcon={<UnCheckedIcon />}
													indeterminate={
														checkedUser &&
														checkedUser.length > 0 &&
														getSelectedUserLength() > 0 &&
														localRoleList.length > getSelectedUserLength()
													}
												/>
											}
											label=''
										/>
										<Typography
											variant='body2'
											className={sortingColumn === 'label' ? `sort-title ${sortOrder}` : 'sort-title asc'}
											id='sort-name'
										>
											<span className='sortable-label'>
												<span className='txt-wrap'>
													{t('nameLabel')} <SortingIcon />
												</span>
											</span>
										</Typography>
									</ListItem>
								</List>
							</Box>
							<Box className='users-list-content'>
								{localRoleList?.map((item: any, indexVal: number) => {
									return (
										<Box
											className={`users-list-row`}
											key={`selected_user_role_designation_index_${indexVal}`}
											id={`selected_user_role_designation_index_${indexVal}`}
										>
											<List component='ul' disablePadding>
												<ListItem className='user-col1'>
													<FormControlLabel
														control={
															<Checkbox
																disabled={
																	typeof disabledUsers.find(
																		(user: any) => item.performanceRoleId === user?.performanceRoleId
																	) !== 'undefined'
																		? true
																		: false
																}
																checked={
																	typeof checkedUser.find(
																		(user: any) => item.performanceRoleId === user?.performanceRoleId
																	) !== 'undefined'
																		? true
																		: false
																}
																onChange={(e) => onUserSelect(e, item, indexVal)}
																icon={<BorderCheckboxIcon />}
																checkedIcon={<CheckedIcon />}
																indeterminateIcon={<UnCheckedIcon />}
															/>
														}
														label=''
													/>
													<Box className='user-info'>
														<Box className='user-info-details'>
															<Typography variant='body1'>{item.performanceRoleName}</Typography>
														</Box>
													</Box>
												</ListItem>
											</List>
										</Box>
									);
								})}
							</Box>
						</Box>
					) : (
						<></>
					)}
				</Box>
				{localRoleList && localRoleList?.length === 0 ? (
					<NoRecord noRecordMessage={t('mainNoRecord')} subHead={t('noRoleLabel')} noImg={NouserImg} {...props} />
				) : (
					<></>
				)}
			</Box>
		</>
	);
};
